// extracted by mini-css-extract-plugin
module.exports = {"toolbox":"SortButton_toolbox__FofnZ","sortText":"SortButton_sortText__1tZA0"};